import { cn } from '@/utils'
import { DEFAULT_STROKE_COLOR, STROKE_COLOR_VARIATIONS } from './constants'

type AnnotationsColorOptionsProps = {
  selectedColor: string
  setSelectedColor: React.Dispatch<React.SetStateAction<string>>
}
export const AnnotationsColorOptions = ({
  selectedColor,
  setSelectedColor,
}: AnnotationsColorOptionsProps) => {
  return (
    <div className="flex mt-1 mb-2 justify-center flex-wrap ">
      {[DEFAULT_STROKE_COLOR, ...STROKE_COLOR_VARIATIONS].map((color) => (
        <span
          className={cn(
            'rounded-full h-4 w-4 m-1 text-center cursor-pointer hover:scale-125 transition-transform ease-in-out duration-100 border flex items-center justify-center text-xs',
          )}
          key={`color-option--${color}`}
          style={{
            backgroundColor: color,
            color: selectedColor === color ? 'white' : color,
            boxSizing: 'border-box',
          }}
          onClick={() => {
            setSelectedColor(color)
          }}
        >
          &#10003;
        </span>
      ))}
    </div>
  )
}
